import React, { useMemo } from 'react';
import { ordersClosingTodaySpecification } from '../../../utilities/pcDashboard/orderSpecifications';
import { useSearchOrdersQuery } from '../../../API/order/OrderApi';
import { ErrorMessageTW } from '../../../tailwindComponents/errorMessage/ErrorMessageTW';
import { LoadingSpinnerTW } from '../../../tailwindComponents/loadingSpinnerTW/LoadingSpinnerTW';
import { MetricCard } from './MetricCard';
import { clientUrls } from '../../../ui-toolkit/rest/ClientUrlFactory';
import { FolderIcon } from '@heroicons/react/24/outline';

export const OrdersClosingToday: React.FC = () => {
  const ordersClosingToday = useMemo(() => ordersClosingTodaySpecification(), []);
  const {
    data: closingTodayData,
    isFetching: closingTodayIsFetching,
    error: closingTodayError,
  } = useSearchOrdersQuery(ordersClosingToday);

  if (closingTodayError) {
    return (
      <div className={'flex-1'}>
        <ErrorMessageTW rtkError={closingTodayError} />
      </div>
    );
  }

  return (
    <LoadingSpinnerTW isLoading={closingTodayIsFetching}>
      <MetricCard
        href={clientUrls.urlFor.adminOrders(ordersClosingToday)}
        title={'Orders Closing Today'}
        data={closingTodayData?.totalElements ?? 0}
        icon={<FolderIcon className={'text-white'} />}
        iconClassName={'bg-emerald-500'}
      />
    </LoadingSpinnerTW>
  );
};
